export default "__VITE_ASSET__DhSHenpA__"